import React, { useEffect, useState } from 'react';
import { FaArrowRight } from "react-icons/fa6";
import Slider from "react-slick";
import { Modal } from 'react-bootstrap';
import { FaCheck } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";
import axios from 'axios';
import { Bounce, toast } from 'react-toastify';
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

const CustomPrevArrow = ({ onClick }) => (
    <button className="slick-prev" onClick={onClick}>
        <i class="fa-solid fa-arrow-left-long"></i>
    </button>
);

const CustomNextArrow = ({ onClick }) => (
    <button className="slick-next" onClick={onClick}>
        <i class="fa-solid fa-arrow-right-long"></i>
    </button>
);
const initialState = {
    name: "",
    email: "",
    phone: "",
    companyName: "",
    message: "",
    errors: {},
    disabled: false,
}
const Landing = () => {

    const [value, setValue] = useState()
    
    console.log("value",value)

    const [istate, upadateIstae] = useState(initialState)
    const { name, email, phone, companyName, message, errors, disabled } = istate;

    const inputHandler = (e) => {
        const { name, value } = e.target
        upadateIstae({ ...istate, [name]: value ,errors:{}})
    }
    const handleValidation = () => {
        let error = {};
        let formValid = true;

        if (!name?.trim()) {
            error.nameError = "*Name cannot be empty*"
            formValid = false
        }
        if (!email?.trim()) {
            error.emailError = "*Email cannot be empty*"
            formValid = false
        } else {
            if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
                error.emailError = "*Email format is not valid*"
                formValid = false
            }
        }
        if (!companyName?.trim()) {
            error.companyNameError = "*Company Name cannot be empty*"
            formValid = false
        }
        if (!message?.trim()) {
            error.messageError = "*Message name cannot be empty*"
            formValid = false
        }
        upadateIstae({ ...istate, errors: error })
        return formValid
    }
    const saveHandler = async (e) => {
        e.preventDefault();
        let formValid = handleValidation();
        if (formValid) {
            try {
                upadateIstae({ ...istate, disabled: true })
                const data = { name, email, phone:value, companyName, message }
                const res = await axios.post(`https://api.sympologix.com/api/v1/mail/send-query-mail`, data);
                console.log(res,"checking response")
                if (res?.data?.code == 200) {
                    setShow(true);
                    // toast.success(res?.data?.message, {                      
                    //         position: "top-right",
                    //         autoClose: 5000,                                         
                    // });
                    upadateIstae(initialState);
                    setValue(""); 
                } else {
                    toast.error(res?.data?.message, {                      
                        position: "top-right",
                        autoClose: 5000,                
                })
                    upadateIstae({ ...istate, disabled: false })
                }

            } catch (err) {
                console.log(err, "errorrr")
                upadateIstae({ ...istate, disabled: false })
            }
        }

    }
    
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 1024, // When screen width is 1024px or less
                settings: {
                    slidesToShow: 2,  // Show 2 slides
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false, // Enable dots for navigation
                    prevArrow: <CustomPrevArrow />,
                    nextArrow: <CustomNextArrow />,
                },
            },
            {
                breakpoint: 768, // When screen width is 768px or less
                settings: {
                    slidesToShow: 1,  // Show 1 slide
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false, // Enable dots for navigation
                    prevArrow: <CustomPrevArrow />,
                    nextArrow: <CustomNextArrow />,
                },
            },
        ],
    };
    const [isFixed, setIsFixed] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 70) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 275) { // Adjust scroll threshold as needed
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    // offset start
    
    useEffect(() => {
        // Function to handle the smooth scroll logic
        const handleScroll = (event) => {
            const href = event.currentTarget.getAttribute("href");
    
            if (href && href.startsWith("#")) {
                event.preventDefault();  // Prevent the default anchor action
                const targetId = href.substring(1);  // Get the target id from href
                const targetElement = document.getElementById(targetId);
    
                if (targetElement) {
                    // Get the height of the navbar to offset the scroll position
                    const headerHeight = document.querySelector(".navbar").offsetHeight;
                    
                    // Conditional offset for different screen sizes
                    let offset = 0;
    
                    if (window.innerWidth <= 576) {
                        offset = -225;  // Offset for mobile screens <= 576px
                        
                        // Apply specific offset for one section (e.g., contactUs section)
                        if (targetId === "solutions") {
                            offset = -125;  // Custom offset for the contact section
                        }
                    } else if (window.innerWidth <= 767) {
                        offset = 10;  // Offset for screens <= 767px
                    } else {
                        offset = 0;  // Offset for larger screens
                    }
    
                    // Scroll to the target element with the calculated offset
                    window.scrollTo({
                        top: targetElement.offsetTop - headerHeight - offset,
                        behavior: "smooth",
                    });
                }
            }
        };
    
        // Select all anchor links with a class of 'nav-link'
        const links = document.querySelectorAll('a.nav-link');
    
        // Add click event listeners to all links
        links.forEach(link => {
            link.addEventListener("click", handleScroll);
        });
    
        // Cleanup function to remove event listeners
        return () => {
            links.forEach(link => {
                link.removeEventListener("click", handleScroll);
            });
        };
    }, []);
    

    // offset end 

    const [activeLink, setActiveLink] = useState('');

    useEffect(() => {
        const options = {
            root: null, // viewport
            rootMargin: '0px',
            threshold: 0.5, // trigger when 50% of the section is in view
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setActiveLink(entry.target.id);  // Set active link based on section ID
                }
            });
        }, options);

        // Observe each section
        const sections = document.querySelectorAll('section');
        sections.forEach(section => observer.observe(section));

        return () => {
            sections.forEach(section => observer.unobserve(section)); // Clean up observer on component unmount
        };
    }, []);

    const [isCollapsed, setIsCollapsed] = useState(true);

    const handleLinkClick = (link) => {
        setActiveLink(link);
        setIsCollapsed(true); // Close the navbar collapse when a link is clicked
    };

    return (
        <>
            <div className={`headerMain ${isFixed ? "fixed" : ""}`}>
                <header>
                    <nav className="navbar navbar-expand-lg navbar-light">
                        <div className="container-fluid">
                            <a className="navbar-brand" href="#home">
                                <img
                                    src={require('../assets/images/logo.png')}
                                    alt="img"
                                    className="logo"
                                />
                            </a>
                            <button
                                className="navbar-toggler"
                                type="button"
                                onClick={() => setIsCollapsed(!isCollapsed)} // Toggle navbar collapse
                                aria-controls="navbarSupportedContent"
                                aria-expanded={!isCollapsed ? 'true' : 'false'}
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div
                                className={`collapse navbar-collapse ${isCollapsed ? '' : 'show'}`}
                                id="navbarSupportedContent"
                            >
                                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${activeLink === 'solutions' ? 'active' : ''}`}
                                            href="#solutions"
                                            onClick={() => handleLinkClick('solutions')}
                                        >
                                            Solutions
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${activeLink === 'tailorYard' ? 'active' : ''}`}
                                            href="#tailorYard"
                                            onClick={() => handleLinkClick('tailorYard')}
                                        >
                                            Transform Your Yard
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${activeLink === 'trustedUsLeaders' ? 'active' : ''}`}
                                            href="#trustedUsLeaders"
                                            onClick={() => handleLinkClick('trustedUsLeaders')}
                                        >
                                            Trusted by Leaders
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${activeLink === 'insightsArea' ? 'active' : ''}`}
                                            href="#insightsArea"
                                            onClick={() => handleLinkClick('insightsArea')}
                                        >
                                            Yard Management Future
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a
                                            className={`nav-link ${activeLink === 'contactUs' ? 'active' : ''}`}
                                            href="#contactUs"
                                            onClick={() => handleLinkClick('contactUs')}
                                        >
                                            Contact Us
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>
            </div>
            <div className='heroSection' id="home">
                <div className="container">
                    <div className="heroContent">
                        <h2>Optimize Your Yard Operations with <br />Sympologix: Efficiency Meets Innovation</h2>
                        <p>Sympologix empowers businesses to streamline yard management through our advanced SaaS solutions. From real-time tracking to automated workflows, our platform enhances operational efficiency, reduces costs, and ensures seamless logistics for distribution centers, manufacturing yards and cold storage facilities.</p>
                        <div className='Buttons'>
                            {/* <a href="javascript:void(0);" className='getStarted'>Get Started Today</a> */}
                            <a href="#contactUs" className={`requestDemo ${scrolled ? 'scrolled' : ''}`}>Get Started Now</a>
                        </div>
                        <img src={require('../assets/images/container-img.png')} alt="img" />
                    </div>
                </div>
            </div>
            <section className='firstCurve'>
            </section>
            <section className='leadingFuture' id="solutions">
                <div className="container">
                    <div className="section-title">
                        <h3>Leading the Future of Yard Management Solutions</h3>
                        <p>At Sympologix, we are dedicated to transforming yard operations across North America. With a focus on innovation and customer-centric solutions, our mission is to provide scalable and customizable software that addresses the unique challenges of various industries. Our commitment to excellence ensures that your operations are efficient, compliant, and ahead of the curve.</p>
                    </div>
                    <div className="row gy-4">
                        <div className="col-lg-4 col-md-6 ">
                            <div className="lfBox">
                                <span className='icon'><img src={require('../assets/images/feature-1.svg').default} alt="img" /></span>
                                <h3>Real-Time Tracking</h3>
                                <p>Monitor trucks, trailers, and containers with live tracking and instant updates.</p>
                                <a href="javascript:void(0);">Learn More<FaArrowRight /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="lfBox">
                                <span className='icon'><img src={require('../assets/images/feature-2.svg').default} alt="img" /></span>
                                <h3>AI-Driven Scheduling</h3>
                                <p>Flexible appointment scheduling with automated confirmations and reminders.</p>
                                <a href="javascript:void(0);">Learn More<FaArrowRight /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="lfBox">
                                <span className='icon'><img src={require('../assets/images/feature-3.svg').default} alt="img" /></span>
                                <h3>Seamless Integration</h3>
                                <p>Paperless, automated check-ins for drivers and carriers.</p>
                                <a href="javascript:void(0);">Learn More<FaArrowRight /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 offset-lg-2 col-md-6">
                            <div className="lfBox">
                                <span className='icon'><img src={require('../assets/images/feature-4.svg').default} alt="img" /></span>
                                <h3>Customizable Dashboards</h3>
                                <p>Stay in control with actionable insights tailored to your operations</p>
                                <a href="javascript:void(0);">Learn More<FaArrowRight /></a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="lfBox">
                                <span className='icon'><img src={require('../assets/images/feature-5.svg').default} alt="img" /></span>
                                <h3>Mobile Accessibility</h3>
                                <p>Manage your yard operations anytime, anywhere with our intuitive mobile application</p>
                                <a href="javascript:void(0);">Learn More<FaArrowRight /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='secondCurve'>
            </section>
            <section className='tailorYardArea' id="tailorYard">
                <div className="section-title">
                    <h2>Tailored Yard Management for Diverse Industries</h2>
                    <p>Our SaaS platform is designed to cater to the specific needs of various sectors</p>
                </div>
                <div className="row">
                    <div className="col-lg-7">
                        <div className="tailorYardLeft">
                            <figure><img src={require('../assets/images/tailor-left.png')} alt="img" className='img-fluid' /></figure>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="leaderfBox">
                            <span className='icon'><img src={require('../assets/images/tailor-2.svg').default} alt="img" /></span>
                            <h3>Distribution Centers</h3>
                            <p>Accelerate turnaround times with real-time visibility and intelligent scheduling.</p>
                        </div>
                        <div className="leaderfBox">
                            <span className='icon'><img src={require('../assets/images/tailor-3.svg').default} alt="img" /></span>
                            <h3>Manufacturing Yards</h3>
                            <p>Enhance workflow automation and asset tracking to boost productivity.</p>
                        </div>
                        <div className="leaderfBox">
                            <span className='icon'><img src={require('../assets/images/tailor-1.svg').default} alt="img" /></span>
                            <h3>Cold Storage Facilities</h3>
                            <p>Maintain optimal temperatures and streamline trailer movements to prevent spoilage and enhance efficiency.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='readyOperations'>
                <h2>Ready to revolutionize your yard <br /> operations? </h2>
                <a href="#contactUs" className='scheduleBtn'>Schedule a Demo Today!</a>
            </section>
            <section className='trustedIndustry' id='trustedUsLeaders'>
                <div className="section-title">
                    <h2>Trusted by Industry Leaders</h2>
                </div>
                <Slider {...settings}>

                    <div className="tiBoxMain">
                        <div className="tiBox">
                            <figure>
                                <img src={require('../assets/images/profile-1.png')} alt="img" />
                                <figcaption>
                                    <h6>Sarah T.</h6>
                                    <p>Operations Manager</p>
                                </figcaption>
                            </figure>
                            <h5>The platform's seamless integration with our existing systems has been a game-changer for our facilities</h5>
                        </div>
                    </div>

                    <div className="tiBoxMain">
                        <div className="tiBox">
                            <figure>
                                <img src={require('../assets/images/profile-2.png')} alt="img" />
                                <figcaption>
                                    <h6>Maninder S.</h6>
                                    <p>Logistics Manager</p>
                                </figcaption>
                            </figure>
                            <h5>The platform is intuitive and integrates seamlessly with our existing systems. Sympologix is a game-changer for our cold storage facilities</h5>
                        </div>
                    </div>

                    <div className="tiBoxMain">
                        <div className="tiBox">
                            <figure>
                                <img src={require('../assets/images/profile-3.png')} alt="img" />
                                <figcaption>
                                    <h6>James S.</h6>
                                    <p>Operations Manager</p>
                                </figcaption>
                            </figure>
                            <h5>Sympologix transformed how we manage our yard operations. The real-time tracking and automation features have saved us countless hours and reduced costs significantly.</h5>
                        </div>
                    </div>

                    <div className="tiBoxMain">
                        <div className="tiBox">
                            <figure>
                                <img src={require('../assets/images/profile-1.png')} alt="img" />
                                <figcaption>
                                    <h6>Sarah T.</h6>
                                    <p>Operations Manager</p>
                                </figcaption>
                            </figure>
                            <h5>The platform's seamless integration with our existing systems has been a game-changer for our facilities</h5>
                        </div>
                    </div>

                    <div className="tiBoxMain">
                        <div className="tiBox">
                            <figure>
                                <img src={require('../assets/images/profile-2.png')} alt="img" />
                                <figcaption>
                                    <h6>Maninder Singh</h6>
                                    <p>Logistics Manager</p>
                                </figcaption>
                            </figure>
                            <h5>The platform is intuitive and integrates seamlessly with our existing systems. Sympologix is a game-changer for our cold storage facilities</h5>
                        </div>
                    </div>

                    <div className="tiBoxMain">
                        <div className="tiBox">
                            <figure>
                                <img src={require('../assets/images/profile-3.png')} alt="img" />
                                <figcaption>
                                    <h6>James S.</h6>
                                    <p>Operations Manager</p>
                                </figcaption>
                            </figure>
                            <h5>Sympologix transformed how we manage our yard operations. The real-time tracking and automation features have saved us countless hours and reduced costs significantly.</h5>
                        </div>
                    </div>

                </Slider>
                {/* <div className="row">
                        <div className="col-lg-4">
                            <div className="tiBox">
                                <figure>
                                    <img src={require('../assets/images/profile-1.png')} alt="img" />
                                    <figcaption>
                                        <h6>Sarah T.</h6>
                                        <p>Operations Manager</p>
                                    </figcaption>
                                </figure>
                                <h5>The platform is intuitive and integrates seamlessly with our existing systems. Sympologix is a game-changer for our cold storage facilities</h5>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="tiBox">
                                <figure>
                                    <img src={require('../assets/images/profile-1.png')} alt="img" />
                                    <figcaption>
                                        <h6>John D.</h6>
                                        <p>Operations Manager</p>
                                    </figcaption>
                                </figure>
                                <h5>Sympologix transformed how we manage our yard operations. The real-time tracking and automation features have saved us countless hours and reduced costs significantly.</h5>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="tiBox">
                                <figure>
                                    <img src={require('../assets/images/profile-3.png')} alt="img" />
                                    <figcaption>
                                        <h6>James S.</h6>
                                        <p>Operations Manager</p>
                                    </figcaption>
                                </figure>
                                <h5>The platform's seamless integration with our existing systems has been a game-changer for our facilities</h5>
                            </div>
                        </div>
                    </div> */}

            </section>
            <section className='insightsArea' id='insightsArea'>
                <div className="container">
                    <div className="section-title">
                        <h2>Insights into Yard Management Excellence</h2>
                    </div>
                    <div className="row gy-5">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="insightsBox">
                                <figure>
                                    <img src={require('../assets/images/insite-1.png')} alt="img" />
                                </figure>
                                <figcaption>
                                    {/* <p className='icon'>Feb <br /> <span>03</span></p> */}
                                    {/* <h6>Townhome</h6> */}
                                    <h3>Enhancing Efficiency in Cold Storage Facilities through Advanced Yard Management</h3>
                                </figcaption>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="insightsBox">
                                <figure>
                                    <img src={require('../assets/images/insite-2.png')} alt="img" />
                                </figure>
                                <figcaption>
                                    {/* <p className='icon'>Feb <br /> <span>03</span></p> */}
                                    {/* <h6>Villa</h6> */}
                                    <h3>Top Trends in Yard Management for Distribution Centers</h3>
                                </figcaption>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="insightsBox">
                                <figure>
                                    <img src={require('../assets/images/insite-3.png')} alt="img" />
                                </figure>
                                <figcaption>
                                    {/* <p className='icon'>Feb <br /> <span>03</span></p> */}
                                    {/* <h6>Townhome</h6> */}
                                    <h3>Maximizing ROI with SaaS-Based Yard Management Solutions</h3>
                                </figcaption>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <section className='contactArea' id='contactUs'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="contactLeft">
                                <h2>It's simple to connect with Sympologix. Let’s optimize your yard operations together.</h2>
                                <p>Have questions or ready to experience Sympologix in action? Reach out to our team today and take the first step toward optimized yard management</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contactRight">
                                <form>
                                    <div className="formBox">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                placeholder='Enter Name'
                                                name='name'
                                                value={name}
                                                onChange={inputHandler}
                                            />
                                            <span style={{ color: 'red' }} >{errors.nameError}</span>
                                        </div>
                                        <div className="form-group">
                                            <label>Company Name</label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                placeholder='Enter Company Name'
                                                name='companyName'
                                                value={companyName}
                                                onChange={inputHandler}
                                            />
                                            <span style={{ color: 'red' }} >{errors.companyNameError}</span>
                                        </div>
                                        <div className="form-group">
                                            <label>Email <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className='form-control'
                                                placeholder='example@gmail.com'
                                                name='email'
                                                value={email}
                                                onChange={inputHandler}
                                            />
                                            <span style={{ color: 'red' }} >{errors.emailError}</span>
                                        </div>
                                        
                                        <div className="form-group">
                                            <label>Phone</label>
                                            <div className='d-flex'>
                                            <PhoneInput
                                                placeholder="Enter phone number"
                                                value={value}
                                                onChange={setValue} className='form-control' />
                                            {/* <input type="number"
                                                className='form-control'
                                                placeholder='Enter phone'
                                                name='phone'
                                                value={phone}
                                                onChange={inputHandler} /> */}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>Message </label>
                                            <textarea
                                                className='form-control'
                                                placeholder='Write Here'
                                                rows={5}
                                                name='message'
                                                value={message}
                                                onChange={inputHandler}  >
                                            </textarea>
                                            <span style={{ color: 'red' }} >{errors.messageError}</span>
                                        </div>
                                        <button type='submit' className='submitBtn' onClick={saveHandler} disabled={disabled}>Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <span className='overlay'><img src={require('../assets/images/line-shape.png')} alt="img" /></span>
            </section>
            <footer>
                <div className="footerArea">
                    <a href="#home">
                        <img src={require('../assets/images/logo.png')} alt="img" className='Logo' />
                    </a>
                    <ul className='Links'>
                        <li><a href="#solutions">Solutions</a></li>
                        <li><a href="#tailorYard">Transform Your Yard</a></li>
                        <li><a href="#trustedUsLeaders">Trusted by Leaders</a></li>
                        <li><a href="#insightsArea">Yard Management Future</a></li>
                        <li><a href="#contactUs">Contact Us</a></li>
                    </ul>
                    <div className="socialLinks">
                        <a href="javascript:void(0);"><img src={require('../assets/images/social-1.png')} alt="img" /></a>
                        <a href="javascript:void(0);"><img src={require('../assets/images/social-2.png')} alt="img" /></a>
                        <a href="javascript:void(0);"><img src={require('../assets/images/social-3.png')} alt="img" /></a>
                        <a href="javascript:void(0);"><img src={require('../assets/images/social-4.png')} alt="img" /></a>
                        <a href="javascript:void(0);"><img src={require('../assets/images/social-5.png')} alt="img" /></a>
                    </div>
                </div>
            </footer>
            <Modal classID='ModalBox' show={show} onHide={handleClose}>
                <div className="ModalArea">
                    <a className='closeBtn' onClick={handleClose}><IoCloseSharp /></a>
                    <div className="logOutArea">
                        <span><FaCheck /></span>
                        {/* <h3>Congratulation!!</h3> */}
                        <p>Thank you for connecting with us. We will reach out to you within 24 hours. Have a fantastic day!</p>
                        <button onClick={handleClose}>Okay</button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default Landing;
